module.exports = __webpack_public_path__ + "media/images/heroes/make-d3c52453bb5840b8c05e5706e4674d4e.png";